module.exports = __webpack_public_path__ + "img/style-two-pin-marker.be441218.svg";